export default "__VITE_PUBLIC_ASSET__8cecbf89__"